import * as React  from 'react';
// import { connect } from 'react-redux'
// import { bindActionCreators } from 'redux';
import Base from './base';
import { Field} from 'redux-form';
import FormSelectSearch from '../../FormComponents/formSelectSearch';

class State extends Base{
    constructor(props){
        super(props);
    }

    renderOnCard() {
        let {renderType, data, showLabel=false,preAppendComma=false, includeSpace=false, returnValueForBlank = "-"} = this.props;
        if(Array.isArray(data))
            data = data[0];
        const value = (data.Value ? (preAppendComma ? ',':'')+""+(includeSpace?" ": "")+data.Value : returnValueForBlank);
        if(renderType.toLowerCase() === 'activity'){
            return (showLabel) ?
                    (<li data-test={data.Label}><label>{data.Label}: </label>{value}</li>)
                :
                    value
        } else if(renderType.toLowerCase() === 'workkard'){
            return (showLabel) ?
                    (<React.Fragment><label>{data.Label} </label>{value}</React.Fragment>)
                :
                    value
        } else{
            return (showLabel) ?
                    (<React.Fragment><label>{data.Label}: </label>{value}</React.Fragment>)
                :
                    value
        }
    }
    renderOnGrid() {
        let {renderType, data, showLabel=false,preAppendComma=false, includeSpace=false, returnValueForBlank = "-"} = this.props;
        if(Array.isArray(data))
            data = data[0];
        const value = (data.Value ? (preAppendComma ? ',':'')+""+(includeSpace?" ": "")+data.Value : returnValueForBlank);
        if(renderType.toLowerCase() === 'activity'){
            return (showLabel) ?
                    (<li data-test={data.Label}><label>{data.Label}: </label>{value}</li>)
                :
                    value
        } else if(renderType.toLowerCase() === 'workkard'){
            return (showLabel) ?
                    (<React.Fragment><label>{data.Label} </label>{value}</React.Fragment>)
                :
                    value
        } else{
            return (showLabel) ?
                    (<React.Fragment><label>{data.Label}: </label>{value}</React.Fragment>)
                :
                    value
        }
    }
    renderOnDetail() {
        let {renderType, data, showLabel=false,preAppendComma=false, includeSpace=false, returnValueForBlank = "-"} = this.props;
        if(Array.isArray(data))
            data = data[0];
        const value = (data.Value ? (preAppendComma ? ',':'')+""+(includeSpace?" ": "")+data.Value : returnValueForBlank);
        if(renderType.toLowerCase() === 'activity'){
            return (showLabel) ?
                    (<li data-test={data.Label}><label>{data.Label}: </label>{value}</li>)
                :
                    value
        } else if(renderType.toLowerCase() === 'workkard'){
            return (showLabel) ?
                    (<React.Fragment><label>{data.Label} </label>{value}</React.Fragment>)
                :
                    value
        } else{
            return (showLabel) ?
                    (<React.Fragment><label>{data.Label}: </label>{value}</React.Fragment>)
                :
                    value
        }
    }

    renderOnCreate() { 
        return (
            <Field
                component={FormSelectSearch}
                wrapperClass=""
                className=""
                Id={this.props.data[0].Name}
                name={this.props.data[0].Name}
                type="text"
                options ={this.props.states}
                iconName = "chev"
                openOnHover = {false}
                openOnClick = {true}
                title = {this.props.selectStateTitle ===""?this.props.placeholder:this.props.selectStateTitle} 
                styleClass = "icon"
                widthClass = ""
                selected = {this.props.selectedState}
                isDisabled={this.props.data[0].IsNonEditable}
                onSelect = {(option)=>this.props.onSelect(option)}

            />
        )
    }
}

export default State;